var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import Icon from "./icon.svg";
var Native = Icon;
var Web = function (props) { return (React.createElement("svg", __assign({}, props, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 141.73 141.73" }),
    React.createElement("g", { id: "Capa_2", "data-name": "Capa 2" },
        React.createElement("g", { id: "Capa_1-2", "data-name": "Capa 1" },
            React.createElement("path", { d: "M136.7,19.55a5.54,5.54,0,0,0-6,5L130,32.61A69.89,69.89,0,0,0,8.42,38.44a5.53,5.53,0,1,0,9.86,5,58.86,58.86,0,0,1,102.4-4.88L112.79,33a5.54,5.54,0,1,0-6.44,9l23.94,17.1a5.54,5.54,0,0,0,8.73-4l2.69-29.49A5.54,5.54,0,0,0,136.7,19.55Z" }),
            React.createElement("path", { d: "M130.9,95.85a5.54,5.54,0,0,0-7.45,2.41,58.86,58.86,0,0,1-102.4,4.88l7.9,5.64a5.53,5.53,0,0,0,6.43-9L11.44,82.67a5.55,5.55,0,0,0-8.73,4L0,116.16a5.54,5.54,0,1,0,11,1l.73-8a69.89,69.89,0,0,0,121.53-5.83A5.53,5.53,0,0,0,130.9,95.85Z" }))))); };
export default { Native: Native, Web: Web };
